import api from "./api";


const getCollections = (search) => {

  return api.get("/collection",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getCollection = (id) => {
  return api.get("/collection/"+id)
  .then((response) => {
    return response.data;
  });
};

const updateCollection = (collection) => {
  return api.patch("/collection",
  {
    ...collection
  })
  .then((response) => {
    return response.data;
  });
};


const CollectionSevice = {
getCollections,
getCollection,
updateCollection,
};

export default CollectionSevice;